export default "__VITE_ASSET__oLTlD6dU__"